module.exports = __webpack_public_path__ + "media/loan_payments_calculator/loan_payment_info-1b2f9b9f.png";